export class TimerFormats {
	id: number;
	value: string;
	label: string;
	groupId: number;

	constructor(options: { id: number; value: string; label: string; groupId: number }) {
		this.id = options.id;
		this.value = options.value || '';
		this.label = options.label || '';
		this.groupId = options.groupId;
	}
}
